<template>
	<div class="omapi-guides__guide omapi-omu__grid-item omapi-card__fourth">
		<a
			v-if="img"
			class="item-thumb guide-thumb has-thumb"
			:href="url"
			target="_blank"
			rel="noopener"
			@click="maybeUpsell"
		>
			<img :height="img.height" :width="img.width" :src="img.source_url" />
		</a>
		<a
			v-else
			class="item-thumb guide-thumb no-thumb"
			:href="url"
			target="_blank"
			rel="noopener"
			@click="maybeUpsell"
		>
			<!-- eslint-disable-next-line vue/no-v-html -->
			<span class="guide-title" v-html="guide.title" />
		</a>
		<h4 class="omapi-guides__guide-title">
			<!-- eslint-disable-next-line vue/no-v-html -->
			<a :href="url" target="_blank" rel="noopener" @click="maybeUpsell" v-html="guide.title" />
		</h4>
		<a
			:href="url"
			target="_blank"
			rel="noopener"
			class="omapi-link-arrow-after omapi-link-underline"
			@click="maybeUpsell"
			>View Guide</a
		>
	</div>
</template>

<script lang="js">
import { debug } from '@/utils'
import { markingSso } from '@/components/mixins/markingSso'
import { upsell } from '@/university/mixins/upsell'

export default  {
	mixins : [ markingSso, upsell ],
	props : {
		guide : {
			type     : Object,
			required : true,
		},
	},
	data () {
		return {
			utmMedium : 'UniversityGuide',
		}
	},
	computed : {
		url () {
			return this.marketingUrl(this.guide.link, 'University')
		},
		img () {
			let { img } = this.guide

			if (img && debug.enabled('guide-media')) {
				img.source_url = img.source_url.replace('optinmonster.test', 'optinmonster.com')
			}

			return img
		},
	},
};
</script>
